module.exports = [{
	id: 'svsi',
	questions: [{
		id: '1',
		text: 'Hast du ein eigenes Unternehmen?',
		type: 'single',
		choices: [{
			id: '1',
			text: 'Ja'
		}, {
			id: '2',
			text: 'Ich gründe gerade'
		}, {
			id: '3',
			text: 'Ich habe eine Idee'
		}]
	}, {
		id: '2',
		text: 'Welche Rolle spielt Software in Deinem Unternehmen / bei Deiner Idee?',
		type: 'single',
		choices: [{
			id: '1',
			text: 'Ohne Software kann ich mein Produkt nicht anbieten'
		}, {
			id: '2',
			text: 'Ich will mit Software meine Kosten senken'
		}, {
			id: '3',
			text: 'Mein Kern-Geschäftsmodells basiert nicht auf Software'
		}]
	}, {
		id: '3',
		text: 'Was unterscheidet Dich von Deinen Konkurrenten? (Mehrfachnennung möglich)',
		type: 'multiple',
		choices: [{
			id: '1',
			text: 'Neues Produkt / Neue Dienstleistung'
		}, {
			id: '2',
			text: 'Einzigartige User Experience / Kundenservice'
		}, {
			id: '3',
			text: 'Effizientere Prozesse / besonders schnelle Dienstleistung'
		}, {
			id: '4',
			text: 'Besondere / nischige Produktpalette'
		}, {
			id: '5',
			text: 'Günstigere Preise'
		}]
	}, {
		id: '4',
		text: 'Brauchst Du Software, um Dich von der Konkurrenz abzuheben?',
		type: 'single',
		choices: [{
			id: '1',
			text: 'Ja'
		}, {
			id: '2',
			text: 'Nein'
		}, {
			id: '3',
			text: 'Ich bin mir nicht sicher'
		}]
	}]
}];
